<template>

    <div id="company-info">
        <div id="logo text-center">
            <img alt="company logo" class="mx-auto d-block img-fluid img-thumbnail" :src="company_logo"/>
            <h5 class="text-center py-3" id="name"><span class="blurred-text">{{$t('Company name')}}</span></h5>
        </div>
        <div id="contact-details">
            <p class="location text-muted"><i class="fa fa-globe-europe fa-2x fa-fw"></i><span class="blurred-text">{{$t('Country')}}</span>
            </p>
            <p class="location text-muted"><i class="fa fa-map fa-2x fa-fw"></i>&nbsp<span
                class="blurred-text">{{$t('Location')}}</span></p>
            <h5 class="mt-3">{{contact_string}}</h5>
            <p class="text-muted"><i class="fa fa-envelope-open fa-2x fa-fw"></i>&nbsp;<span class="blurred-text">email@example.org</span>
            </p>
            <p class="text-muted"><i class="fa fa-phone-square fa-2x fa-fw"></i>&nbsp;<span class="blurred-text">00 000 000</span>
            </p>
            <p class="text-muted"><i class="fa fa-file-alt fa-2x fa-fw"></i>&nbsp;<span class="blurred-text">http://www.example.org</span>
            </p>
        </div>
    </div>

</template>
<script>
    export default {
        props: ['company_logo', 'contact_string'],
        data() {
            return {}
        },
        mounted() {}
    }
</script>

<style scoped>
    #company-info {
        background-color: #ebf2f7;
        padding: 1.8em;
    }

    #company-info i {
        vertical-align: middle;
        color: #005a93;
        padding-right: 0.2em;
    }
</style>
